import { convertCase } from '../../_utils/utils'
import * as clone from 'clone'
import { stripUndefined } from '../../_utils/strip-undefined'
import { CampaignAudienceEvaluationFrequency } from '../../enums/campaign-audience-evaluation-frequency'

function getCleanIdArray(arr: number[]) {
    arr = arr.filter((v) => v !== null && v !== undefined).map((v) => parseInt(v.toString(), 10))

    return Array.from(new Set(arr))
}

export class CampaignAudienceModel {
    public static build(data: CampaignAudienceModel | any): CampaignAudienceModel {
        const scData = convertCase(clone(data), 'snake')
        const model = new CampaignAudienceModel()

        model.setSegmentIds(scData.segment_ids)
        model.setExcludedSegmentIds(scData.excluded_segment_ids)
        model.setEvaluationFrequency(scData.evaluation_frequency ?? CampaignAudienceEvaluationFrequency.STEP_ENTRY)
        model.setDefaultIconUrl(scData.default_icon_url)

        return model
    }

    private segment_ids?: number[]
    private excluded_segment_ids?: number[]
    private evaluation_frequency?: CampaignAudienceEvaluationFrequency
    private default_icon_url?: string

    public clone(): CampaignAudienceModel {
        return CampaignAudienceModel.build(this)
    }

    public serialize(_: boolean = true): any {
        return stripUndefined({
            segment_ids: this.getSegmentIds(),
            excluded_segment_ids: this.getExcludedSegmentIds(),
            evaluation_frequency: this.getEvaluationFrequency(),
            default_icon_url: this.getDefaultIconUrl(),
        })
    }

    public setSegmentIds(segmentIds: number[] | undefined): void {
        this.segment_ids = segmentIds === undefined ? undefined : getCleanIdArray(segmentIds)
    }
    public getSegmentIds(): number[] | undefined {
        return this.segment_ids
    }
    public addSegmentId(segmentId: number) {
        if (!this.segment_ids || !this.segment_ids.includes(segmentId)) {
            this.setSegmentIds([...(this.segment_ids ?? []), segmentId])
        }
    }

    public setExcludedSegmentIds(segmentIds: number[] | undefined): void {
        this.excluded_segment_ids = segmentIds === undefined ? undefined : getCleanIdArray(segmentIds)
    }
    public getExcludedSegmentIds(): number[] | undefined {
        return this.excluded_segment_ids
    }
    public addExcludedSegmentId(segmentId: number) {
        if (!this.excluded_segment_ids || !this.excluded_segment_ids.includes(segmentId)) {
            this.setExcludedSegmentIds([...(this.excluded_segment_ids ?? []), segmentId])
        }
    }

    public getEvaluationFrequency(): CampaignAudienceEvaluationFrequency | undefined {
        return this.evaluation_frequency
    }
    public setEvaluationFrequency(freq: CampaignAudienceEvaluationFrequency | any): void {
        this.evaluation_frequency = freq
    }

    public getDefaultIconUrl(): string | undefined {
        return this.default_icon_url
    }
    public setDefaultIconUrl(url: string | undefined): void {
        this.default_icon_url = url
    }
}
